import styled from 'styled-components';

import colors from 'styles/colors';
import { COMMENT_CELL_CLASS, SINGLE_LINE_CLASS } from './constants';

export const RatingHistoryTableStyled = styled.div`
  width: 100%;
  overflow-y: auto;

  table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: 8px;
      border-bottom: 1px solid ${colors.gray_scale3};
      font-size: 14px;
      line-height: 1.5;
      text-align: left;
      vertical-align: baseline;

      &.${SINGLE_LINE_CLASS} {
        white-space: nowrap;
      }
      
      &.${COMMENT_CELL_CLASS} {
        min-width: 200px;
      }
    }

    th {
      font-weight: 600;
      background: ${colors.gray_scale5};
    }

    tr:last-child td {
      border-bottom: none;
    }

    p {
      margin: 0;
      font-size: 14px;
      line-height: 1.5;
      text-align: left;
      white-space: pre-wrap;
    }
  }
`;
